import styled from 'styled-components'

export const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
    display: grid;
    width: 500px;
  }
`
export const UserSoldContainer = styled.div`

    flex: 1;
    display: flex;
    flex-direction: row;
    margin-top:40px;

`
export const UserSoldLeftContainer = styled.div`
    border: 3px solid #7e7d7a;
    display: flex;
    flex-direction: column;
    margin-right:50px;
    width:25%;
    height:60%;
    border-radius: 15px;

    i{
            margin:8px 8px;
            font-size:40px;

        }
`
export const PerfilPictureContainer = styled.div`

    .perfil-picture-background{
            border-radius: 50%;
            border:6px solid black;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 251px;
            height: 251px;
            margin: 20px 50px;
    }

        img{
            width: 244px;
            height: 244px;
            border-radius:50%;
            }

`
export const UserSoldFeatureContainerBotton = styled.div`

    display:flex;
    align-items:flex-start;
    flex-direction:column;
    margin:30px;


`
export const PerfilNameSinceContainer = styled.div`

    .user-name-container{
            display: flex;
            align-items: center;
            justify-content: center;
            color: #002666;
            font-weight:bold;
    }

    .user-since-container{
            display: flex;
            align-items: center;
            justify-content: center;
            color:#535353;
            font-weight:bold;
            font-size:12px;

    }

`
export const MySellerContainer = styled.div`

        margin-top:10px;

    .my-seller{
        color:#303030;
        font-size:25px;
        display: flex;
        align-items: center;
        justify-content: center;
    }


    .my-seller-secondary-property{
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        margin:20px;
        list-style:none;
    }
`
export const MyPurchaseContainer = styled.div`

    color:#303030;
    font-size:25px;
    display: flex;
    align-items: center;
    justify-content: center;


`
export const PaymentContainer = styled.div`

    color:#303030;
    font-size:25px;
    display: flex;
    align-items: center;
    justify-content: center;
`
export const ConfigurationContainer = styled.div`


    .configuration{
        color:#303030;
        font-size:25px;
        display: flex;
        align-items: center;
        justify-content: center;

    }

    .configuration-secondary-property{
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        margin:20px;
        list-style:none;

    }
`


// >>>>>>>>>>>CONTAINER DIREITO<<<<<<<<<<


export const UserSoldRightContainer = styled.div`
    border: 3px solid #7e7d7a;
    width:75%;
    height:35%;
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    border-radius:15px;

      @media (max-width: 768px) {
        height: 80%;
        position: unset;
      }
`
export const UserEmailTitle = styled.div`

    border-bottom: 2px solid #7e7d7a;
    display: flex;
    flex-direction:row;
    align-items: center;
    margin: 20px;
    color: #002666;
    font-size: 26px;
    margin-bottom:6px;
    margin-top: 60px;
    i{
        font-size:60px;
        margin-right: 20px;
    }

`
export const MsgFunctionality = styled.div`


    font-style:bold;
    font-size: 20px;
    margin: 10px;
    margin-left: 20px;
    color: black;
`
export const EmailSettingsContainer = styled.div`

  .email-status-config{
    display: flex;
    flex-direction:row;
    align-items: center;
    justify-content: space-between;
    align-items: center;
    list-style:none;
    margin:10px 30px 0 30px;
    padding-bottom: 10px;
    border-bottom: 1px #646161 solid;
    &:last-child{
        border-bottom: none;
        margin-bottom: 30px;
    }
    label{
        margin: 0;
    }
  }
  .email-checkbox-wrapper{

    display: flex;
    flex-direction:row;
    align-items: flex-end;
    border: 3px solid #002666 ;
    border-radius: 5px;
    padding: 5px;
    margin-right: 10px;
  }





`
// >>>>>>>>>>>>>>>>>>>Container Botton<<<<<<<<<<<<<<<<<


export const UserSoldContainerBot = styled.div`
    display: flex;
    flex-direction:column;
    position: absolute;
    bottom: -145px;
    left: -3px;
    width: 100%;

    @media (max-width: 768px) {
    position: static;
  }
    div{
        font-size:14px;
        margin-bottom:25px;
    }
    button{
        background-color: #CE1720;
        color:white;
        font-weight:bold;
        font-size:22px;
        width:130px;
        height:60px;
        border-radius: 10px;
    }

`